 <template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        :breadcrumbs="breadcrumbs"
        icon="mdi-format-list-checkbox"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mx-1">
        <v-col cols="12" class="content_category rounded-lg">
          <v-row class="mx-3">
            <v-col cols="6">
              <v-select
                  background-color="#EDF2F7"
                  filled
                  v-model="category.brand_id"
                  :items="brands"
                  item-text="name"
                  item-value="id"
                  label="Chọn nhãn hàng"
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  label="Tên"
                  v-model="category.name"
                  placeholder="Nhập tên category"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  label="Slug"
                  v-model="category.slug"
                  placeholder="Nhập tên slug"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <ck-content class="ck-categry" :content="category.description" @getData="value => category.description = value"/>

            </v-col>
            <v-col cols="4">
              <v-file-input
                  label="Ảnh đại diện"
                  placeholder="Tải ảnh lên"
                  prepend-icon="mdi-camera"
                  @change="fileSelected"
              ></v-file-input>
              <v-img
                  :src="src"
              ></v-img>
            </v-col>
            <v-col cols="12" class="text-center">
              <v-btn
                  color="primary"
                  width="180"
                  @click="save_category()"
              >
                Lưu
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="content_category mt-3 rounded-lg">
              <v-row class="mx-3">
                <v-col cols="3" class="d-flex mt-5 pa-0 pb-2">
                  <h4>SEO</h4>
                </v-col>
                <v-col cols="12" class="pa-0">
                    <v-text-field
                      background-color="#EDF2F7"
                      filled
                      @blur="triggerSeo"
                      label="SEO Title"
                      placeholder="Nhập SEO Title"
                      v-model="category.meta_title"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" class="pa-0 pb-2">
                    <v-textarea
                      class="content-textarea"
                      background-color="#EDF2F7"
                      filled
                        @blur="triggerSeo"
                      label="SEO Description"
                      placeholder="Nhập mô tả"
                      v-model="category.meta_description"
                    >
                    </v-textarea>
                </v-col>
              </v-row>
            </v-col>

            <seo 
              @getKeywords="getKeywords"
              :trigger_seo="count_trigger_seo"
              :text_seo="text_seo"
              :keywords="category.meta_keyword"
              :meta_title="category.meta_title"
              :content="category.description"
              :slug="category.slug"
              :meta_description="category.meta_description"
              :col="12"
            />
            <v-col cols="12" class="text-center">
              <v-btn
                  color="primary"
                  width="180"
                  @click="save_category()"
              >
                Lưu
              </v-btn>
            </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import {UPDATE_CATEGORY_POST, UPLOAD_CATEGORY_POST_IMAGE,GET_DETAIL_CATEGORY_POST} from '@/store/modules/category_post'
import {GET_LIST_BRAND} from '@/store/modules/brand'
// import {UPLOAD} from '@/store/modules/upload'
import {mapGetters} from 'vuex'
import CkContent from "@/components/ck-content"
import Seo from "@/components/seo"
import { replaceCkContent } from '@/utils/helpers'
export default {
  components:{
    CkContent,
    Seo
  },
  data() {
    return {
      text_seo: "",
      SEO: [],
      count_trigger_seo: 0,
      list_imgs: [],
      src:'',
      image: {},
      hasImage: false,
      selectedFile:null,
      block:{
        name:'',
        count:0
      },
      page: "Quản lý category",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true
        },
        {
          text: "Quản lý bài viết",
          disabled: true,
        },
        {
          text: "Quản lý category",
          disabled: true,
        },
        {
          text: "Thêm category",
          disabled: true,
        },
      ],

    };
  },
  computed:{
    ...mapGetters({
      brands: "brands",
      category: "categoryPostDetail",
      seos: "seos",
    })
  },
  async created(){
    await this.$store.dispatch(`${GET_DETAIL_CATEGORY_POST}`, this.$route.params.id);
    await this.$store.dispatch(`${GET_LIST_BRAND}`);
  },
  watch:{
    category(val){
      // const _this = this;
      if(val && val.photo_url){
        this.src = val.photo_url_path
      }
    },
  },
  methods:{
    addBlock() {
      this.category.list_attribute.push({
        name: this.block.name,
        // count: this.block.count++,
      })
      this.$forceUpdate()
    },
    clearBlock(i, index){
      this.category.list_attribute.splice(index, 1)
      this.$forceUpdate()
    },
    fileSelected(event) {
      const _this = this;
      if (!event) {
        console.log(123)
      } else {
        this.src = ''
        this.image = event;
        this.src = URL.createObjectURL(this.image);
        let formData = new FormData();
        formData.append("upload", this.image);
        formData.append("type", "categories");
        this.$store.dispatch(`${UPLOAD_CATEGORY_POST_IMAGE}`, formData).then((data) => {
          if (data && data.data && data.data.data) {
            data.data.data.forEach(element => {
              _this.category.photo_url = element.path ?? '';
              _this.category.thumb_url = element.thumb_path ?? '';
            })
          }
        })
      }
    },

    save_category(){
      let data_category = {
        id:this.category.id,
        name:this.category.name,
        parent_id:this.category.parent_id,
        brand_id:this.category.brand_id,
        description:replaceCkContent(this.category.description),
        slug:this.category.slug,
        photo_url: this.category.photo_url,
        thumb_url: this.category.thumb_url,
        meta_title: this.category.meta_title,
        meta_description: this.category.meta_description,
        meta_keyword: this.category.meta_keyword,
      }
      console.log(data_category);
      this.$store.dispatch(`${UPDATE_CATEGORY_POST}`, data_category).then((data)=>{
        if (data.data.status==1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration:1000,
            position:'top-center'
          })
          this.$router.push('/manage_news/Manage_category')
        }else{
          alert(data.data.errors)
        }
      });
    },
    triggerSeo(){
      this.count_trigger_seo++;
    },
    getKeywords(keywords){
      this.category.meta_keyword = keywords
    }
  }
};
</script>
<style lang="scss">
.content_category {
  background: #ffffff !important;
.content-textarea .v-input__control {
  height: 165px!important;
}
}
.ck-categry .ck-editor__main .ck-content {
  height: 40px;
}
</style>